import { config } from "JS/Config";
import {
    PurchasableGift,
    GiftToSend,
    GiftGiven,
    ReceivedGift,
} from "JS/Models/Media";
import { BaseService } from "../BaseService";
import { OldUser } from "JS/Models";
import { appConstants } from "JS/Helpers/Constants";

export class GiftService extends BaseService {
    private endpoints = appConstants.ngEndpoints;
    getPurchasableGifts(contentType: string) {
        return this.ngCall<PurchasableGift[]>(
            "get",
            this.endpoints.purchasableGifts(config.user.memberId),
            {
                params: {
                    contentType,
                },
            },
        );
    }

    getReceivedGifts(contentType: string) {
        return this.ngCall<ReceivedGift[]>(
            "get",
            this.endpoints.receivedGifts(config.user.memberId),
            {
                params: {
                    contentType,
                },
            },
        );
    }

    getToSendMediaGifts(contentType: string) {
        return this.ngCall<GiftToSend[]>(
            "get",
            this.endpoints.purchasedGifts(config.user.memberId),
            {
                params: {
                    contentType,
                },
            },
        );
    }

    getMemberGiftQuantity(sku: string) {
        return this.ngCall<{ quantity: number }>(
            "get",
            this.endpoints.memberGiftQuantity(config.user.memberId),
            {
                params: {
                    skuId: sku,
                },
            },
        );
    }

    getProspectGiftQuantity(sku: string) {
        return this.ngCall<{ quantity: number }>(
            "get",
            this.endpoints.prospectGiftQuantity(config.user.memberId),
            {
                params: {
                    skuId: sku,
                },
            },
        );
    }

    allMembersOfGroup() {
        return this.ngCall<OldUser[]>(
            "get",
            this.endpoints.groupMembers(config.user.memberId, "My LOS"),
        );
    }

    sendGift(giftSkus: string[], receivers: string[], contentType: string) {
        return this.ngCall<never>("post", this.endpoints.sendGift, {
            memberId: config.user.memberId,
            receivers,
            giftSkus: giftSkus,
            contentType,
        });
    }

    isProspectingUser() {
        return this.ngCall<boolean>(
            "get",
            this.endpoints.isProspectingUser(config.user.memberId),
        );
    }

    syncDYS(email: string, password: string) {
        return this.ngCall<never>(
            "post",
            this.endpoints.syncDYS(config.user.memberId),
            {
                email,
                password,
            },
        );
    }

    getUserName() {
        return this.ngCall<OldUser>(
            "get",
            this.endpoints.userName(config.user.memberId),
        );
    }

    getGiftReceivers() {
        return this.ngCall<OldUser[]>(
            "get",
            this.endpoints.giftReceivers(config.user.memberId),
        );
    }

    getGiftsGiven(memberId: string) {
        return this.ngCall<GiftGiven[]>(
            "get",
            this.endpoints.giftsSent(config.user.memberId, memberId),
        );
    }
}
